// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icons-container[data-v-6978e530]{position:relative}.check-icon[data-v-6978e530],.graduation-cap-icon[data-v-6978e530]{color:#fff}.graduation-cap-icon[data-v-6978e530]{width:23px;height:auto;z-index:-10}.check-icon[data-v-6978e530]{position:absolute;width:15px;height:auto;top:12px;left:14px;z-index:100;border-radius:50%}.is-completed[data-v-6978e530]{color:#05164d}.non-completed[data-v-6978e530]{color:#dcdcdc}", ""]);
// Exports
module.exports = exports;
